import { Observable } from 'rxjs';
import { HolidayApiProvider } from './../../shared/nestjs/attendance/holiday-api';
import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';

@Injectable()
export class HolidaySettingBloc {

    private subscriptions: Array<Subscription> = [];


    constructor(
        private holidayApi: HolidayApiProvider
    ) { }

    dispose() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe)
    }

    getHoliday(data): Observable<any> {
        return this.holidayApi.getHoliday(data);
    }

    addHoliday(dataAdd): Observable<any> {
        return this.holidayApi.addHoliday(dataAdd);
    }

    editHoliday(dataEdit): Observable<any> {
        return this.holidayApi.editHoliday(dataEdit);
    }

    downloadTemplateHoliday(): Observable<any> {
        return this.holidayApi.downloadTemplateHoliday();
    }

    deleteHoliday(id) {
        return new Promise((resolve, reject) => {
            this.holidayApi.deleteHoliday(id)
                .subscribe(async (response) => {
                    resolve(response)
                }, error => {
                    reject(error)
                })
        })
    }
}


// WEBPACK FOOTER //
// ./src/bloc/settings/holiday-setting.bloc.ts